import { useEffect, useMemo, useState } from "react";
import { BadgeCheck, Star } from "lucide-react";
import { REVIEWS_URL } from "../config/site";
import "./ProductReviews.css";

export default function FeaturedReviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    fetch(REVIEWS_URL, { cache: "no-store", signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error("No se pudieron cargar las reseñas.");
        return response.json();
      })
      .then((document) => setReviews(document.reviews || []))
      .catch((error) => {
        if (error.name !== "AbortError") setReviews([]);
      });

    return () => controller.abort();
  }, []);

  const activeReviews = useMemo(
    () => reviews.filter((review) => review.active),
    [reviews],
  );
  const featuredReviews = activeReviews
    .filter((review) => review.featured)
    .sort((first, second) => String(second.date).localeCompare(String(first.date)))
    .slice(0, 3);

  if (activeReviews.length < 8 || featuredReviews.length < 2) return null;

  return (
    <section className="featured-reviews" aria-labelledby="featured-reviews-title">
      <header>
        <p>Experiencias Imalandia</p>
        <h2 id="featured-reviews-title">Fotos que ya encontraron su sitio</h2>
      </header>

      <div>
        {featuredReviews.map((review) => (
          <article key={review.id}>
            <span className="product-reviews-stars" aria-label={`${review.rating} de 5 estrellas`}>
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  aria-hidden="true"
                  className={star <= review.rating ? "is-filled" : ""}
                />
              ))}
            </span>
            <blockquote>“{review.text}”</blockquote>
            <footer>
              <strong>{review.authorName}</strong>
              {review.verifiedPurchase && (
                <small><BadgeCheck aria-hidden="true" /> Compra verificada</small>
              )}
            </footer>
          </article>
        ))}
      </div>
    </section>
  );
}
